export default "__VITE_ASSET__678d9a0c__"